import { Injectable } from '@angular/core';
import {Auth} from './auth.service';
import {
  CanActivate,
  Router,
} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Authguard implements CanActivate {

  constructor(public auth: Auth, public router: Router) { }

  async canActivate(): Promise<boolean> {
    if (await this.auth.isAuthenticated()) {
      return true;
    }
    else {
      this.router.navigate(['login']);
      return false;
    }
  }
}
